import { mensagemDeErro } from '@/lib/erros';
import { toast } from '@/ui/primitives/aviso';
import { Button } from '@/ui/primitives/button';
import { Dialog } from '@/ui/primitives/dialog';
import { type RegraClassificacao } from '@fiscoai/contracts';

import { useApagarRegra } from './api';
import { itens } from './textos';

interface Props {
  empresaId: string;
  regra: RegraClassificacao | null;
  aoFechar: () => void;
}

function consequencia(regra: RegraClassificacao): string {
  if (regra.itens === 0) return 'Nenhum item está classificado por ela hoje.';
  const voltam = regra.itens === 1 ? 'volta' : 'voltam';
  return `${itens(regra.itens)} que ela classificou ${voltam} para "a classificar", a menos que outra regra os pegue.`;
}

/** Confirma apagar dizendo o que acontece com os itens; os classificados à mão não mudam. */
export function DialogoApagarRegra({ empresaId, regra, aoFechar }: Props) {
  const apagar = useApagarRegra(empresaId);
  const confirmar = async () => {
    if (!regra) return;
    try {
      await apagar.mutateAsync(regra.id);
      toast.success('Regra apagada');
      aoFechar();
    } catch (erro) {
      toast.error(mensagemDeErro(erro));
    }
  };
  return (
    <Dialog
      aberto={regra !== null}
      aoMudar={(aberto) => {
        if (!aberto) aoFechar();
      }}
      titulo={regra ? `Apagar a regra ${regra.nome}?` : 'Apagar regra'}
      descricao={regra ? consequencia(regra) : undefined}
      acoes={
        <>
          <Button variante="fantasma" onClick={aoFechar}>
            Cancelar
          </Button>
          <Button variante="perigo" carregando={apagar.isPending} onClick={() => void confirmar()}>
            Apagar regra
          </Button>
        </>
      }
    >
      <p className="text-sm text-texto-suave">Os itens classificados à mão continuam como estão.</p>
    </Dialog>
  );
}
